"use client"

import { ProductCard } from "@/components/common/product-card"
import type { DeviceWithQty } from "@/server/api/cartActions"
import SkeletonLoader from "../_components/all-products-skeleton"

interface ProductsGridProps {
  products: DeviceWithQty[]
  isLoading: boolean
  error?: Error | null
}

export function ProductsGrid({
  products,
  isLoading,
  error,
}: ProductsGridProps) {
  if (isLoading) {
    return <SkeletonLoader />
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center w-full gap-12 max-sm:mt-16">
        <img src="/error.svg" alt="error" className="sm:size-40 size-32" />
        <p className="text-center font-gilroySemiBold sm:text-xl">
          Something went wrong. Please try again.
        </p>
      </div>
    )
  }

  if (products?.length === 0) {
    return (
      <div className="flex flex-col justify-center items-center w-full gap-12 max-sm:mt-16">
        <img
          src="/no-products.svg"
          alt="no products found"
          className="sm:size-40 size-32"
        />
        <p className="text-center font-gilroySemiBold sm:text-xl">
          No Products Available
        </p>
      </div>
    )
  }

  return (
    <div className="flex flex-wrap gap-1 xs:gap-3 lg:gap-y-8 sm:px-0 justify-between xs:justify-evenly sm:justify-start items-start w-full mb-2 lg:mb-8">
      {products?.map((product, i) => (
        <ProductCard
          key={`${i}-${product?.device_name}`}
          product={product}
          res={3}
        />
      ))}
    </div>
  )
}
